
  
<div class="container-loader" *ngIf="isBusy" [ngStyle]="{'height': '100%'}">
  <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
</div>
<div class="modal-header">
  <h6 class="modal-title"><span *ngIf="title">{{ title }}</span><span *ngIf="!title">{{ popTitle }}</span></h6>
  <div class="actions-container" *ngIf="actions.length > 0">
    <span *ngFor="let action of actions">
      <input type="button" *ngIf="!action.DisplayOnGroup" value="{{ action.ActionDisplay }}" class="btn btn-primary mr-2 btn-action others" (click)="setCurrentAction(action)">
    </span>
  </div>
  <button type="button" class="close close-modal" data-dismiss="modal" aria-label="Close" (click)="closeCard()" title="Close">
    <span aria-hidden="true" style="font-size: 25px;">&times;</span>
  </button>
</div>
<div #modalBody class="modal-body custom-scrollbar popup-body" [ngStyle]="{'overflow-y': isBusy ? 'hidden' : 'auto'}">
  <app-detail #detailpopup [setComponentId]='componentId' 
    (title)="setTitle($event)" (hidePopup)="hide()" [isPopupDetail]="true" 
    (loadingPopup)="handleLoading($event)" (detailActions)="setActions($event)" [actionOnDetail]="currentAction" [isPreview]="isPreview"></app-detail>
</div>